import { useUiSettings } from '@/Contexts/UiSettingsProvider';
import useTypedPage from '@/Hooks/useTypedPage';
import { useState } from 'react';

export default function useTopBanner() {
  const { settings, setSettings } = useUiSettings();
  const { props } = useTypedPage();
  const topBanner = props.top_banner;

  const isDismissed =
    topBanner?.alert_banner_id === settings.topBannerDismissed;

  const [showTopBanner, setShow] = useState(
    !isDismissed && topBanner.alert_banner && topBanner.alert_banner_message,
  );

  const dismissTopBanner = () => {
    setShow(false);
    const dismissedTopBanner = topBanner?.alert_banner_id;
    setSettings(prev => ({
      ...prev,
      topBannerDismissed: dismissedTopBanner,
    }));
  };

  return {
    topBanner,
    showTopBanner,
    dismissTopBanner,
  };
}
